import {DivIcon} from "leaflet";
import {
    ADD_POINT_ICON_MUTATE_SINGLE_VOYAGE
} from "@containers/singleVoyage/mutateVoyage/points/map/addPointOnTheMap/helpers/icon";

export const buildIconAddPointMutateSingleVoyage = ()=>{
    return new DivIcon({
        html: ADD_POINT_ICON_MUTATE_SINGLE_VOYAGE,
        popupAnchor: [-10, -10],
        iconSize: [40, 29],
    });
}